import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Logo } from "../components/AppShell";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { adminReset, formatErr } from "../lib/api";
import { toast } from "sonner";

export default function AdminReset() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.length < 8) { toast.error("Mínimo 8 caracteres"); return; }
    if (pwd !== confirm) { toast.error("Las contraseñas no coinciden"); return; }
    if (!token) { toast.error("Token inválido"); return; }
    setLoading(true);
    try {
      await adminReset(token, pwd);
      toast.success("Contraseña actualizada");
      navigate("/admin/login");
    } catch (err) { toast.error(formatErr(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="app-shell">
      <div className="app-frame flex flex-col">
        <header className="px-5 py-4 border-b border-slate-100">
          <Logo size={32} withWordmark />
        </header>
        <main className="flex-1 px-5 py-8 fade-in flex flex-col justify-center">
          <h1 className="text-3xl font-[Outfit] font-extrabold tracking-tight text-slate-900">
            Nueva contraseña
          </h1>
          <p className="text-sm text-slate-600 mt-1">Crea una nueva contraseña segura.</p>
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="reset-form">
            <div className="space-y-1.5">
              <Label className="text-sm">Nueva contraseña (mín. 8)</Label>
              <Input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)}
                data-testid="input-reset-pwd" required />
            </div>
            <div className="space-y-1.5">
              <Label className="text-sm">Confirmar</Label>
              <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
                data-testid="input-reset-confirm" required />
            </div>
            <Button type="submit" disabled={loading}
              className="btn-primary h-12 rounded-xl w-full font-semibold"
              data-testid="btn-reset-submit">
              {loading ? "Guardando..." : "Cambiar contraseña"}
            </Button>
          </form>
        </main>
      </div>
    </div>
  );
}
